import { render } from "./InfoNav.vue?vue&type=template&id=4f460681&scoped=true"
import script from "./InfoNav.vue?vue&type=script&lang=js"
export * from "./InfoNav.vue?vue&type=script&lang=js"

import "./InfoNav.vue?vue&type=style&index=0&id=4f460681&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.39_vue@3.5.39_typescript@5.9.3__webpack@5.109.2_cssna_em6n5doortrigby6mckty5jpxy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f460681"]])

export default __exports__